import React from 'react'
import LogoImage from "../../../mbh/styles/images/berkeley-logo.svg"
import MobileLogoImage from "../../../mbh/styles/images/berkeley-logo-mobile.svg"
import { route } from '../../../mbh/utils/route'
import { useNavigate } from 'react-router-dom'

const CustomHeader = ({
  className = "column15"
}) => {

  return (
		<div className={`${className} brandLogo`}>
			<a
				tabindex='0'
				className='dInlineBlock'
				id='siteLogo'
				href='https://www.the-berkeley.co.uk/'
			>
				<img
					className='desktopLogo'
					src={LogoImage}
					alt='berkeley logo'
				/>
				<img
					className='mobileLogo'
					src={MobileLogoImage}
					alt='Mobile berkeley logo'
				/>
			</a>
		</div>
  );
}

export default CustomHeader